import { Section } from './anUi';
import { TokensTable } from './Tables';

export default function TokensTab({ d }) {
  return (
    <Section icon="🪙" title="Historique complet des tokens" right={d.tokenRows.length > 0 && <span className="an-count">{d.tokenRows.length}</span>}>
      {d.tokenRows.length === 0
        ? <p className="an-empty-inline">Aucun token détecté.</p>
        : <TokensTable rows={d.tokenRows} variant="full" />}
    </Section>
  );
}
